import React from 'react';

import styles from './ContactUs.module.scss';

const ContactUs = (data) => {
  return (
    <>
      {data?.data?.map((item, index) => {
        return (
          <div
            key={index}
            className={styles.contactUs}
            itemScope
            itemType='https://schema.org/ContactOption'
          >
            <span className={styles.title}>{item?.title}</span>
            <div className={styles.contactListWrapper}>
              <ul className={styles.contactList}>
                {item?.contacts?.map((contact, index) => {
                  if (contact?.type === 'phone') {
                    return (
                      <li key={index}>
                        <a
                          href={`tel:${item?.value}`}
                          target='_blank'
                          rel='nofollow noopener noreferrer'
                          className={styles.contactItems}
                        >
                          {contact?.text}
                        </a>
                      </li>
                    );
                  }
                  if (contact?.type === 'email') {
                    return (
                      <li key={index}>
                        <a
                          href={`mailto:${item?.value}`}
                          className={styles.contactItems}
                          target='_blank'
                          rel='nofollow noopener noreferrer'
                        >
                          {contact?.text}
                        </a>
                      </li>
                    );
                  }
                  return null;
                })}
              </ul>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default ContactUs;
